<template>
  <div v-if="model">
    <div class="position-relative">
      <select @change="emitUpdate" class="form-control form-select" v-model.trim="value" :disabled="isDisabled">
        <option :value="null">{{ trans('Séléctionnez une option') }}</option>
        <option :key="choice.id" :value="choice.code" v-for="choice in choices">
          {{ trans(choice.label) }}
        </option>
      </select>
      <div class="input-check pe-10">
        <i class="fad fa-check-circle text-primary"></i>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({})
export default class PropertyRadio extends Vue {
  @Prop() itemUuid!: string
  @Prop() propertyCode!: string
  @Prop({default: false}) isDisabled!: boolean

  get item() {
    return this.$store.getters["contractStore/getEntity"]('items', this.itemUuid)
  }

  get model() {
    if (!this.item) return null
    const itemType = this.$store.state.contractStore.itemTypes[this.item.modelCode]
    if (!itemType?.properties) return null
    return (Object.values(itemType.properties) as any[]).find((pm: any) => pm.code === this.propertyCode) || null
  }

  get choices() {
    return Object.values(this.model?.choices || {})
  }

  get value() {
    return this.item?.properties?.[this.propertyCode]
  }

  set value(v: any) {
    if (this.item) {
      Vue.set(this.item.properties, this.propertyCode, v)
    }
  }

  emitUpdate() {
    this.$emit('propertyUpdated', {code: this.propertyCode, itemUuid: this.itemUuid})
  }
}
</script>

<style scoped>
</style>
